// Loading.js
import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Logo from '../../assets/icon.png'
import LinearProgress from '@mui/material/LinearProgress';

const Loading = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 2001,
                width: '100%',
                '& > * + *': {
                    marginTop: 0
                }
            }}
        >
            <LinearProgress color="secondary" />
        </Box>
    )
}

export default Loading
